module.exports = __webpack_public_path__ + "static/frame-5014f6abb9f530975dbbca4e30836b2a.svg";